import { getAllowedAdminDomains } from '@cdw-ae/common-data';
import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  firebase: {
    apiKey: 'AIzaSyBmb9sPZy5O5K4ziqJuhm3mqFLmZFWD2u0',
    authDomain: 'spog-gopher-develop.firebaseapp.com',
    projectId: 'spog-gopher-develop',
    storageBucket: 'spog-gopher-develop.firebasestorage.app',
    messagingSenderId: '848861775180',
    appId: '1:848861775180:web:75d31f83c6cf88827abbe9',
  },
  urls: {
    backendApi: 'https://spog-backend.dev.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  // Client-side add-time domain allowlist (server is authoritative). Develop
  // accepts the gafetest test domain alongside the real CDW domain.
  allowedAdminEmailDomains: getAllowedAdminDomains('develop'),
  revision: REVISION,
  version: VERSION,
};
